// Product Page Add to cart
    //^^ Extracting variant input data when clicked
    let productVariantLabel = document.querySelectorAll('.WI_proVarLabel');
    let productVariantInput = document.getElementsByClassName('WI_proVarInput');
    productVariantLabel.forEach((label)=>{
        label.addEventListener('click',()=>{
            setTimeout(() => {
                for (let i = 0; i < productVariantInput.length; i++) {
                    if (productVariantInput[i].checked) {
                        let productVarInputData = productVariantInput[i].value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
                        parsingProductJson(productVarInputData);
                    }
                }
            }, 10);
        });
    });
    //^^ Parsing product json and add to cart
    function parsingProductJson(inputData) {
        let productJson = JSON.parse(document.querySelector('.WI_productTemplate_main').querySelector('[type="application/json"]').textContent);
        productJson.forEach((obj)=>{
            let objTitle = obj.title.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
            let productForm = document.querySelector("#WI_pT_form_input");
            
            if (objTitle == inputData) {
                //^^ Variant image changer
                // console.log(obj.price);
                let priceChange = document.getElementById('priceChange');
                let pricewithdiscount = document.getElementById('pricewithdiscount');
                priceChange.innerHTML = (Number(obj.price)/100).toLocaleString('en-GB', {style: 'currency', currency: 'INR'}).split(".")[0];
                 pricewithdiscount.innerHTML = (Number(obj.price)/100 - 100).toLocaleString('en-GB', {style: 'currency', currency: 'INR'}).split(".")[0];
                productForm.value = obj.id;
                if (obj.featured_media.alt && obj.featured_media) {
                    document.querySelectorAll('[tumbnail-alt]').forEach(img=>{img.style.display = "none"});
                    let currentColor = obj.featured_media.alt;
                    let tumbSelector = `[tumbnail-alt = '${currentColor}']`
                    document.querySelectorAll(tumbSelector).forEach(img=>{img.style.display = "block";})
                };
                //^^ Variant stock checker
                let inputStock = obj.available;
                // console.log(inputStock);
                if (inputStock == false) {
                    document.querySelector(".WI_pT_atcBtn").disabled = true;
                    document.querySelector(".WI_pT_atcBtn").style.opacity = "0.5";
                    document.querySelector('.WI_buyNow').style.opacity = "0.4";
                    document.querySelector('.WI_buyNow').style.pointerEvents = "none";
                    document.querySelector('.WI_mobileBuyNow').style.pointerEvents = "none";
                    document.querySelector('.WI_mobileBuyNow').style.opacity = "0.4";
                    document.querySelector("#spanAddToCart").innerHTML = 'Sold Out';
                }else{
                    document.querySelector(".WI_pT_atcBtn").disabled = false;
                    document.querySelector(".WI_pT_atcBtn").style.opacity = "1";
                    document.querySelector('.WI_buyNow').style.opacity = "1";
                    document.querySelector('.WI_buyNow').style.pointerEvents = "all";
                    document.querySelector('.WI_mobileBuyNow').style.pointerEvents = "all";
                    document.querySelector('.WI_mobileBuyNow').style.opacity = "1";
                    document.querySelector("#spanAddToCart").innerHTML = 'Add To Cart';
                }
            }
        })
    };

//Product variant stock
const proVatiantStock = document.querySelectorAll('.WI_proVarLabel');
proVatiantStock.forEach(stock => {
    stock.addEventListener("click", ()=>{
        let stockAttri = Number(stock.getAttribute('data-stock'));
        // console.log(stockAttri);
        if (stockAttri < 10) {
            document.querySelector('.WI_stock').style.display = "flex";
            document.getElementById('stockText').innerHTML = "0"+stockAttri;
        }else{
            document.querySelector('.WI_stock').style.display = "none";
        }
    })
});

// Lazy image load
function imageLazyLoad() {
    let imageLazy = document.querySelectorAll('.lazyLoad');

    function lazyIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				let lazyData = entry.target.getAttribute('data-wisrc');
                entry.target.srcset = lazyData;
                entry.target.style.opacity = "1";
                entry.target.onload=function() { 	
                    entry.target.style.visibility = "visible";
                  entry.target.style.opacity = "1";
                    }
                // console.log(entry);
                observer.unobserve(entry.target);
			}
		});
	};

    const lazyoptions = {
        root: null,
        rootMargin: '400px 0px',
        threshold: 0,
      };

      const observer = new IntersectionObserver(lazyIntersection,lazyoptions);
      imageLazy.forEach(img => {
        observer.observe(img);
      });
};
imageLazyLoad();

// Product Tabs
// const proTabs = document.querySelectorAll('.DTabs');
// proTabs.forEach(tab => {
//     tab.addEventListener("click", ()=>{
//         let allTabs = document.querySelectorAll('.DTabs');
//         allTabs.forEach(alltab => {
//             alltab.classList.remove('WI_des_active');
//         });
//         tab.classList.add('WI_des_active');
//         let dataTab = tab.getAttribute('data-sectionID');
//         if (dataTab == "feature") {
//             document.querySelector(".WI_productDrop_main").scrollIntoView({ behavior: "smooth" });
//         }else if(dataTab == "faq") {
//             document.querySelector(".product-faq-section").scrollIntoView({ behavior: "smooth" });
//         }else if(dataTab == "review") {
//             document.querySelector("#judgeme_product_reviews").scrollIntoView({ behavior: "smooth" });
//         }
//     });
// });

document.addEventListener("DOMContentLoaded", function () {

    const proTabs = document.querySelectorAll('.DTabs');

    proTabs.forEach(tab => {

        tab.addEventListener("click", function () {

            // Remove active class from all tabs
            document.querySelectorAll('.DTabs').forEach(t => {
                t.classList.remove('WI_des_active');
            });

            // Add active to clicked tab
            this.classList.add('WI_des_active');

            const dataTab = this.getAttribute('data-sectionID');

            let targetSelector = '';

            if (dataTab === "feature") {
                targetSelector = ".WI_productDrop_main";
            } else if (dataTab === "faq") {
                targetSelector = ".product-faq-section";
            } else if (dataTab === "review") {
                targetSelector = "#judgeme_product_reviews";
            }

            const target = document.querySelector(targetSelector);

            if (target) {

                // Sticky header offset (adjust height if needed)
                const headerOffset = 100; 
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });

            } else {
                console.warn("Target section not found:", targetSelector);
            }

        });

    });

});


// Product dropdown
const dropDownProductInfo = document.querySelectorAll('.WI_productDrop_heading');
dropDownProductInfo.forEach((drop)=>{
    drop.addEventListener('click',()=>{
        let dropElement = drop.nextElementSibling;
        // console.log(dropElement.style.maxHeight);
        if (dropElement.style.maxHeight != '') {
            dropElement.style.maxHeight = null;
        }else{
            dropElement.style.maxHeight = dropElement.scrollHeight + "px";
        }
    })
});

// Banner group load more 
    // const groupBanner = document.getElementById('WI_bannerGrouo_in');
    // const groupBannerBtn = document.getElementById('WI_bannerGroup_btn');
    // let grpBannerOpen = false;
    // groupBannerBtn.addEventListener('click', ()=>{
    //     if (grpBannerOpen == false) {
    //         groupBannerBtn.innerHTML = 'View Less';
    //         groupBanner.style.height = "auto";
    //         grpBannerOpen = true;
    //     } else {
    //         groupBannerBtn.innerHTML = 'View More';
    //         groupBanner.style.height = "1100px"; 
    //         grpBannerOpen = false;
    //     }
    // });
